var FileUpload = {
  init: function() {
    FileUpload.setupEvents();
  },
  selectors: {
    $modal: $('#crop-modal'),
    $cropImage: $('#crop-image'),
    $cropButton: $('#crop-btn')
  },
  setupEvents: function() {
    var self = this;

    $(document).on('change', '.btn-file :file', function() {
      var input = $(this),
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
      input.trigger('fileselect', [label]);
    });

    $('.btn-file :file').on('fileselect', function(event, label) {  
      var input = $(this).parents('.input-group').find(':text'),
      log = label;
      
      if( input.length ) {
        input.val(log);
      } else {
        if( log ) alert(log);
      }    
    });

    $("#select-image").click(function () {
      $(".picture-preview").click();
    })
  
    $(".picture-preview").change(function(){
      FileUpload.readURL(this);
    });

    self.selectors.$modal.on('show.bs.modal', function() {
      self.selectors.$cropImage.cropper({
        viewMode:1,
        aspectRatio: 1/1,
        minContainerWidth: 460,
        minContainerHeight: 340
      })
    }).on('hidden.bs.modal', function() {
      self.selectors.$cropImage.cropper('destroy');
    });

    self.selectors.$cropButton.on('click', function() {
      var canvas = self.selectors.$cropImage.cropper('getCroppedCanvas', {
        width: 250,
        height: 250,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });

      self.selectors.$modal.modal('hide');

      $('#img-upload').attr('src', canvas.toDataURL());
      $('#base64_picture').attr('value', canvas.toDataURL());
      $('#img-upload-placeholder').addClass('hidden');
      $('#img-upload').removeClass('hidden');
      $('#message-picture').removeClass('hidden');
    });
  },
  readURL: function(input) {
    var self = this;

    var done = function(url) {
      $(".picture-preview").attr('value', '');
      self.selectors.$cropImage.attr('src', url);
      self.selectors.$modal.modal('show');
    }

    if (input.files && input.files.length > 0) {
      var file = input.files[0];

      if (URL) {
        done(URL.createObjectURL(file));
      } else if (FileReader) {
        reader = new FileReader();
        reader.onload = function (e) {
          done(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }
}
$(document).ready(function() {
  FileUpload.init();
});